var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-1"},[_c('v-skeleton-loader',_vm._b({staticClass:"rounded-0 store-img",staticStyle:{"width":"100%"},attrs:{"id":"skeleton-store-img","type":"image"}},'v-skeleton-loader',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }